import { AddressCompletionField, AddressRecoveryReason, type AddressRecoveryRecord } from '@navio/nsdk';
import type { NoddiAsyncError } from 'noddi-types';
import { z } from 'zod';

const recoverySchema = z.object({
  reason: z.enum(AddressRecoveryReason),
  street_name: z.string().nullable(),
  street_number: z.string().nullable(),
  zip_code: z.string().nullable(),
  city: z.string().nullable(),
  country_code: z.string().nullable(),
  missing_fields: z.array(z.enum(AddressCompletionField)),
  street_number_pattern: z.string().optional(),
  zip_code_pattern: z.string().nullable().optional()
});

export const parseAddressRecovery = (error: NoddiAsyncError | null): AddressRecoveryRecord | null => {
  const result = recoverySchema.safeParse(error?.response?.data.error_context?.address_recovery);
  if (!result.success) {
    return null;
  }
  return {
    reason: result.data.reason,
    streetName: result.data.street_name,
    streetNumber: result.data.street_number,
    zipCode: result.data.zip_code,
    city: result.data.city,
    countryCode: result.data.country_code,
    missingFields: result.data.missing_fields,
    streetNumberPattern: result.data.street_number_pattern,
    zipCodePattern: result.data.zip_code_pattern
  };
};
